import { useEffect } from 'react'
import { useStoreState, useStoreRehydrated } from '../store'
import { expireAuthSession, getTokenExpiry } from '../config/auth-session'

export default function useAdminSessionExpiry(appType, model, field) {
	const token = useStoreState(state => state[model][field]?.token)
	const rehydrated = useStoreRehydrated()
	useEffect(() => {
		if (!rehydrated || !token) return
		const expiresAt = getTokenExpiry(token)
		const checkExpiry = () => {
			if (expiresAt == null || Date.now() >= expiresAt) {
				void expireAuthSession({ appType, token })
			}
		}
		checkExpiry()
		const timer = setTimeout(checkExpiry, Math.min(Math.max(0, expiresAt - Date.now()), 2147483647))
		window.addEventListener('focus', checkExpiry)
		document.addEventListener('visibilitychange', checkExpiry)
		return () => {
			clearTimeout(timer)
			window.removeEventListener('focus', checkExpiry)
			document.removeEventListener('visibilitychange', checkExpiry)
		}
	}, [appType, model, field, token, rehydrated])
}
